/**
 * Route definition for /chains/songbird
 *
 * Renders the shared ChainPage with the `songbird` article. Chain facts live in
 * `@/data/chains`; presentation and SEO live in `@/components/ChainPage`.
 *
 * @module routes/chains/songbird
 * @category Routes
 */
import { createFileRoute } from '@tanstack/react-router'
import ChainPage from '@/components/ChainPage'

export const Route = createFileRoute('/$locale/chains/songbird')({
  component: function SongbirdChainPage() {
    return <ChainPage slug="songbird" />
  },
})
